if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        this.showActiveMedia();
        window.playPdpGalleryVideos();
      }

      hide() {
        super.hide();
        window.playPdpGalleryVideos();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
        });

        const activeDeferredMedia = this.querySelector(
          `deferred-media[data-media-id="${mediaId}"]`
        );
        const activeMedia =
          activeDeferredMedia ||
          this.querySelector(`img[data-media-id="${mediaId}"]`);

        if (!activeMedia) return;

        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (activeDeferredMedia) {
          window.playDeferredMedia(activeDeferredMedia);
        }

        window.playPdpGalleryVideos();
      }
    }
  );
}
